import { render, staticRenderFns } from "./EmergencyContact.vue?vue&type=template&id=68cdd729&scoped=true&"
import script from "./EmergencyContact.vue?vue&type=script&lang=js&"
export * from "./EmergencyContact.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyContact.vue?vue&type=style&index=0&id=68cdd729&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cdd729",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68cdd729')) {
      api.createRecord('68cdd729', component.options)
    } else {
      api.reload('68cdd729', component.options)
    }
    module.hot.accept("./EmergencyContact.vue?vue&type=template&id=68cdd729&scoped=true&", function () {
      api.rerender('68cdd729', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/ccd/tenancy/edit/EmergencyContact.vue"
export default component.exports